module.exports = __webpack_public_path__ + "img/docx_type.e89c526c.jpg";